import React from "react";
import PropTypes from "prop-types";
import NumberFormat from "react-number-format";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import { StyledTable, StyledTitle, StyledValue } from "./styles";

const Box = props => {
  const { title, number, styledTitle, className } = props;

  return (
    <React.Fragment>
      <StyledTable className={className}>
        <TableBody>
          <TableRow>
            {styledTitle && (
              <StyledTitle className={className}>
                <span>{styledTitle}</span>
              </StyledTitle>
            )}
            {title && (
              <StyledTitle className={className}>
                <span>{title}</span>
              </StyledTitle>
            )}
            <StyledValue className={className}>
              <NumberFormat
                value={number}
                decimalScale={2}
                displayType="text"
              />{" "}
              %
            </StyledValue>
          </TableRow>
        </TableBody>
      </StyledTable>
    </React.Fragment>
  );
};

Box.propTypes = {
  title: PropTypes.string,
  styledTitle: PropTypes.object,
  number: PropTypes.number,
  className: PropTypes.string
};

export default Box;
